import { render } from "./sleepingarea-17.vue?vue&type=template&id=d17abb5e&scoped=true"
import script from "./sleepingarea-17.vue?vue&type=script&lang=js"
export * from "./sleepingarea-17.vue?vue&type=script&lang=js"

import "./sleepingarea-17.vue?vue&type=style&index=0&id=d17abb5e&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d17abb5e"]])

export default __exports__